import { GameService } from './../../../services/game-service';
import { ICustomElementViewModel, inject, observable } from 'aurelia';
import { bindable } from 'aurelia';
import { Helper } from '../../extensions';
import { SimplebarOverride } from '../../simplebar-override';
import { websiteShortCode } from '../../../environment';
import './db-footer-menu.scss';
import 'simplebar';


@inject(Helper, GameService)
export class DbFooterMenu implements ICustomElementViewModel {
    @bindable dropdown: { name: string, isDropdownMenu?: boolean, showFilter?: boolean, keyName?: string, menuItems: { name: string, routeName: string }[] };
    keyword: string;
    environmentLink: string;
    results: boolean;
    openMenu: boolean = false;
    filteredItems: { name: string, routeName: string }[] = [];
    typeaheadController = {
        active: true, onKeydown: () => { }
    };

    menuOptionsRef: HTMLElement;
    simpleBarInstance: any;
    simpleBar: any;
    shortCode: string | undefined = websiteShortCode();
    page: number = 2;
    pageSize: number = 50;
    tradeNavItemsPage: number = 0;
    tradeNavItemsPageSize: number = 50;

    @observable menuItems: { name: string, routeName: string }[] = [];

    constructor(private helper: Helper, private gameService: GameService) {
        this.environmentLink = this.helper.environmentLink;
    }

    attached() {
        this.menuItems = this.dropdown.menuItems;
        if (this.shortCode === 'CX') {
            this.initSimpleBar();
        }
    }

    detached() {
        if (this.shortCode === 'CX') {
            this.simpleBar?.getScrollElement()?.removeEventListener('scroll', this.handleReachedMenuBottomMenu);
        }
    }

    toggleMenu() {
        return this.openMenu ? this.openMenu = false : this.openMenu = true;
    }

    initSimpleBar() {
        this.simpleBar = new SimplebarOverride(this.menuOptionsRef, {
            clickOnTrack: true,
            scrollbarMinSize: 52,
        });
        this.simpleBar.getScrollElement().addEventListener('scroll', (event) => {
            const { scrollHeight, scrollTop, clientHeight } = event.target as HTMLElement;
            const isBottomReached = (scrollHeight - Math.round(scrollTop) === clientHeight);

            if (isBottomReached) {
                this.handleReachedMenuBottomMenu();
            }
        }, { passive: true });
    }

    async handleReachedMenuBottomMenu() {
        const result = await this.gameService.getGamesByPages(this.page, this.pageSize, this.shortCode);
        const games: { name: string; routeName: string }[] = Array.isArray(result?.results) ? result?.results as { name: string; routeName: string }[] : [];

        if (games.length === 0) {
            return;
        }

        if (this.dropdown.keyName !== 'CX_FOOTER_BUY_SELL_SWAP') return;

        this.dropdown.menuItems = [...this.dropdown.menuItems, ...games];
        this.page += 1;

    };

    async keywordChanged(value: Event, dropdownMenu: {name: string, routeName: string}[]) {
        if (this.shortCode === 'CX') {
            const tradeNavItems = await this.gameService.searchByNamePaginated(
                this.tradeNavItemsPage,
                this.tradeNavItemsPageSize,
                (value.target as HTMLInputElement).value,
            );

            if (tradeNavItems && tradeNavItems.results.length > 0) {
                this.filteredItems = tradeNavItems.results.map(x => ({ name: x.name, routeName: x.slugName }));
            }
            return;
        }

        const key = (value.target as HTMLInputElement).value.toLowerCase();
        this.filteredItems = dropdownMenu.filter(data =>
            data.name.toLowerCase().includes(key)
        );

        if (this.filteredItems.length > 0) {
            this.results = false;
        } else if (this.filteredItems.length === 0) {
            this.results = true;
        }
    }

    get isCX(): boolean {
        return this.shortCode === 'CX';
    }
}
